export default "/img/background.f5eabe7f84f50c853c817b0c448f4fe9.png";